import { TableOutlined } from '@ant-design/icons';
import { Segmented } from 'antd';
import { ReactComponent as BarGraphIcon } from 'assets/icons/BarGraph.svg';
import { ReactComponent as GraphIcon } from 'assets/icons/Graph.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../contexts/AuthContext';
import { AccessType } from '../../types/User';

export type ViewMode = 'table' | 'chart' | 'status';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  className?: string;
}

export default function ViewToggle({ value, onChange }: ViewToggleProps) {
  const { t } = useTranslation();
  const isConcessionnaire = useAuthContext().auth?.user?.accessType === AccessType.CONCESSIONNAIRE;

  const options = [
    {
      label: (
        <div className="flex gap-2 items-center">
          <TableOutlined />
          {t('global:vue_tableau')}
        </div>
      ),
      value: 'table' as ViewMode,
    },
    !isConcessionnaire && {
      label: (
        <div className="flex gap-2 items-center">
          <GraphIcon />
          {t('global:vue_graphique')}
        </div>
      ),
      value: 'chart' as ViewMode,
    },
    {
      label: (
        <div className="flex gap-2 items-center">
          <BarGraphIcon />
          {t('global:vue_statut')}
        </div>
      ),
      value: 'status' as ViewMode,
    },
  ].filter(Boolean) as { label: React.ReactNode; value: ViewMode }[];

  return (
    <Segmented
      value={value}
      onChange={onChange}
      options={options}
      className="view-toggle"
      size="small"
    />
  );
}
